
import { types } from "mobx-state-tree";

export const ValueLabelEntry = types.model("ValueLabelEntry",{
    value: types.integer,
    label: types.string,
})
